import { Navigate, Outlet } from "react-router-dom";
interface ProtectedRouteProps {
  children?: React.ReactNode;
  roles?: string[];
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, roles }) => {
  const rawUserData = localStorage.getItem("user_data");
  let userData: any = null;
  userData = rawUserData ? JSON.parse(rawUserData) : null;
  const token = localStorage.getItem("token");
  const userRole = userData?.roles?.role_name;

  const parsedUser = userData ? userData : null;
  const isAuthenticated = token && parsedUser;

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (roles && parsedUser && !roles.includes(parsedUser?.roles?.role_name)) {
    return <Navigate to="/login" replace />;
  }

  // if user role is client then handle report/run-payroll
  // if (userRole === "Client") {
  //   const params = new URLSearchParams(location.search);
  //   const rawRedirect = params.get("redirect");

  //   if (rawRedirect?.startsWith("/report")) {
  //     const parts = rawRedirect.split("/");
  //     const clientIdEncoded = parts[4];

  //     try {
  //       const clientId = atob(clientIdEncoded);

  //       if (String(clientId) === String(userData?.id)) {
  //         return <Navigate to={rawRedirect} replace />;
  //       }
  //     } catch (err) {
  //     }
  //   }
  // }

  if (children) return <>{children}</>;

  return <Outlet />;
};

export default ProtectedRoute;
